<div class="alert-container" *ngIf="show" (click)='close()'>
  <div class="card" [ngStyle]="{transform: translate}">
    <div class="card-body">
      <h5>{{message}}</h5>
    </div>
    <div class="card-footer">
      <button class='btn btn-primary alert-btn-confirm' (click)='close()'>OK</button>
    </div>
  </div>
</div>